import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001',
});

// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401/403 errors and prevent HTML responses from breaking the app
api.interceptors.response.use(
  (response) => {
    // Safeguard: If the API base URL is wrong (e.g. points to Firebase static domain),
    // we will receive index.html as text/html instead of expected JSON.
    // Checking for this avoids setting HTML string as data state, preventing runtime crashes.
    const contentType = response.headers['content-type'];
    if (typeof contentType === 'string' && contentType.includes('text/html')) {
      return Promise.reject(new Error('API returned HTML. Check that your REACT_APP_API_URL points to the backend server, not the frontend domain.'));
    }
    return response;
  },
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Clear token and redirect to login if unauthorized
      localStorage.removeItem('admin_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
